/**
 * Handle tooltips
 *
 * @param {}
 * @return {void}
 */

$(document).on('click', '.js-tooltip-holder', function(e) {
  e.preventDefault();
});

$(document).on('click', '.js-tooltip-holder .tooltip__icon', function(e) {
  const $tooltip = $(this).closest('.js-tooltip');

  $('.js-tooltip').not($tooltip).removeClass('is-active');
  $tooltip.toggleClass('is-active');
});

$(document).on('click touchstart', function(e) {
  let target = $(e.target);

  if (!target.closest('.js-tooltip, .js-tooltip .js-tooltip-holder, .js-tooltip .js-tooltip-holder *').length) {
    $('.js-tooltip').removeClass('is-active');
  }
});
